module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_6-0f1fd0610cbc17b4a58ec7a5e988e323.svg";